module.exports = __webpack_public_path__ + "static/media/magnet.d9e4c729.svg";